/*
 * Gyász-átmenet — "Amikor a hiány szeretetté alakul" (erezdalelked.hu / Gyászfeldolgozás).
 * Csendes, meditatív interakció: a látogató lassan elhúzza a fogantyút a "hiány" felől
 * a "szeretet, ami marad" felé; a gömb felmelegszik és felragyog, a felirat átalakul.
 * Nem játék — lassú, tiszteletteljes. Vanilla JS, nincs külső könyvtár, section-scope-olt.
 */
(function () {
  'use strict';

  function lerp(a, b, t) { return a + (b - a) * t; }

  function init(root) {
    if (!root || root.__gyInit) return;
    root.__gyInit = true;

    var track  = root.querySelector('[data-gy-track]');
    var handle = root.querySelector('[data-gy-handle]');
    var fill   = root.querySelector('[data-gy-fill]');
    var orb    = root.querySelector('[data-gy-orb]');
    var cap    = root.querySelector('[data-gy-caption]');
    if (!track || !handle) return;

    var CAPS = [
      'A hiány súlya — ami most nehéz.',
      'Lassan teret kap a lélegzet.',
      'A fájdalom oldódik — az emlék marad.',
      'A hiány szeretetté vált. Ami marad, az a szeretet.'
    ];

    var p = 0, dragging = false, capIdx = -1;

    function render() {
      var pc = (p * 100).toFixed(1);
      fill.style.width = pc + '%';
      handle.style.left = pc + '%';
      handle.setAttribute('aria-valuenow', Math.round(p * 100));

      if (orb) {
        // cool grey (#9a96a0) → warm gold (#C5A880)
        var r = Math.round(lerp(154, 197, p));
        var g = Math.round(lerp(150, 168, p));
        var b = Math.round(lerp(160, 128, p));
        orb.style.background = 'radial-gradient(circle at 38% 34%, rgba(' + r + ',' + g + ',' + b + ',0.95) 0%, rgba(' + r + ',' + g + ',' + b + ',0.16) 62%, transparent 78%)';
        orb.style.boxShadow = '0 0 ' + (18 + p * 66).toFixed(0) + 'px rgba(197,168,128,' + (0.08 + p * 0.5).toFixed(3) + ')';
        orb.style.transform = 'scale(' + (0.82 + p * 0.3).toFixed(3) + ')';
        orb.style.opacity = (0.62 + p * 0.38).toFixed(2);
      }

      var idx = p >= 0.8 ? 3 : (p >= 0.5 ? 2 : (p >= 0.25 ? 1 : 0));
      if (cap && idx !== capIdx) {
        capIdx = idx;
        cap.style.opacity = '0';
        setTimeout(function () { cap.textContent = CAPS[idx]; cap.style.opacity = '1'; }, 170);
      }
    }

    function setFromX(clientX) {
      var r = track.getBoundingClientRect();
      p = Math.max(0, Math.min(1, (clientX - r.left) / r.width));
      render();
    }
    function down(e) { dragging = true; setFromX((e.touches ? e.touches[0] : e).clientX); if (e.cancelable) e.preventDefault(); }
    function move(e) { if (!dragging) return; setFromX((e.touches ? e.touches[0] : e).clientX); if (e.cancelable) e.preventDefault(); }
    function up() { dragging = false; }

    track.addEventListener('mousedown', down);
    handle.addEventListener('mousedown', down);
    track.addEventListener('touchstart', down, { passive: false });
    document.addEventListener('mousemove', move);
    document.addEventListener('touchmove', move, { passive: false });
    document.addEventListener('mouseup', up);
    document.addEventListener('touchend', up);

    handle.addEventListener('keydown', function (e) {
      var step = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') step = 0.05;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') step = -0.05;
      else return;
      e.preventDefault();
      p = Math.max(0, Math.min(1, p + step));
      render();
    });

    render();
  }

  function boot() {
    var els = document.querySelectorAll('[data-gyasz]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
